module.exports = __webpack_public_path__ + "themes/mf/img/scratch-bg.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/scratch-bg.png
// module id = 106
// module chunks = 3